import { render, staticRenderFns } from "./RealmDeleteDialogue.vue?vue&type=template&id=54865661&"
import script from "./RealmDeleteDialogue.vue?vue&type=script&lang=js&"
export * from "./RealmDeleteDialogue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports